import { createSelector } from 'reselect';

import { RootState } from '@/app/store';

const selectReferralState = (state: RootState) => state.referral;

export const selectReferralStats = createSelector(selectReferralState, (r) => r.stats);
export const selectReferralLoading = createSelector(selectReferralState, (r) => r.loading);
export const selectReferralClaiming = createSelector(selectReferralState, (r) => r.claiming);
export const selectReferralClaimSuccess = createSelector(selectReferralState, (r) => r.claimSuccess);
export const selectReferralClaimError = createSelector(selectReferralState, (r) => r.claimError);
export const selectReferralCode = createSelector(selectReferralStats, (s) => s?.referralCode ?? null);
export const selectReferralJoining = createSelector(selectReferralState, (r) => r.joining);
export const selectReferralJoinSuccess = createSelector(selectReferralState, (r) => r.joinSuccess);
export const selectReferralJoinError = createSelector(selectReferralState, (r) => r.joinError);
